import React from 'react';

import PropTypes from 'prop-types';

import { CalendarMode } from '@philips-emr/tws-constants';
import { CustomPropTypes } from '@philips-emr/tws-core/lib/component';
import { enumValues } from '@philips-emr/tws-utils';

import { MonthlyWeekdays, WeeklyWeekdays } from '.';

const { oneOf } = CustomPropTypes;

function Weekdays({ mode, date }) {
  let weekdays = null;

  if (mode === CalendarMode.MONTHLY) {
    weekdays = <MonthlyWeekdays />;
  }

  if (mode === CalendarMode.WEEKLY) {
    weekdays = <WeeklyWeekdays date={date} />;
  }

  return <div className="c-calendar__weekdays u-hide@empty">{weekdays}</div>;
}

Weekdays.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  mode: oneOf(enumValues(CalendarMode)),
};

export default Weekdays;
